import React from "react";

const WPVariables = ({ rowData }) => {
  return (
    <div className="modal-list-items mt15">
      <div className="modal-list-item">
        <div className="modal-list-item-title">
          <h3>Variables</h3>
        </div>
        <div className="modal-list-item-content">
          {rowData?.customParams?.map((item, index) => (
            <div key={index} className="variable-item">
              <span className="variable-name">{item?.paramName}:</span>
              <span className="variable-value">{item?.paramValue}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WPVariables;
